@if (show) {
  <div
    class="fixed z-50 top-4 -left-10 -rotate-45 pointer-events-none bg-primary-100 opacity-20 text-text-700 text-center p-2 min-w-40"
    >
    {{ name }}
  </div>
}
